import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap'

import TicketTest from './TicketTest.jsx'
import ExcelTest from './ExcelTest.jsx'
import AlfredTest from './AlfredTest.jsx'

class TestPage extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      tab: 3
    }
  }

  selectTab(tab) { this.setState({tab}) }

  render() {
    return (
      <div>
        <Tabs activeKey={this.state.tab} onSelect={k => this.selectTab(k)} id="tests-tabs">
          <Tab eventKey={3} title="Alfred">
            <AlfredTest />
          </Tab>
          <Tab eventKey={1} title="ExcelMaker">
            <ExcelTest />
          </Tab>
          <Tab eventKey={2} title="Ticket PDFs">
            <TicketTest />
          </Tab>
        </Tabs>
      </div>
    )
  }
}

export default TestPage
